export const LOADER_STATUSES = {
    PENDING: 'pending',
    SUCCESS: 'success',
    ERROR: 'error',
    NONE: 'none',
};
